import { hasAnyRole, hasRole, ROLE_NAMES } from "../../Helpers/roles";

const PACK_MANAGER_ROLES = [ROLE_NAMES.SUPER_ADMIN, ROLE_NAMES.PLANNER];
const EDITABLE_STATUSES = ["Created", "Checked", "Published", "Rejected"];
const REASSIGNABLE_STATUSES = ["Created", "Checked", "Published"];
const VOIDABLE_STATUSES = ["Created", "Checked", "Published", "Rejected", "Cancelled"];

const isSuperAdmin = (user) => hasRole(user, ROLE_NAMES.SUPER_ADMIN);
const isPackManager = (user) => hasAnyRole(user, PACK_MANAGER_ROLES);
const isOwningPlanner = (user, pack) => (
  hasRole(user, ROLE_NAMES.PLANNER) && user?.id === pack?.planner_id
);
const isPrimaryEngineeringSupervisor = (user, pack) => (
  hasRole(user, ROLE_NAMES.ENGINEERING_SUPERVISOR)
  && user?.id === pack?.users?.esusers?.[0]?.user_id
);
const isBeforePlannedEnd = (pack) => {
  const plannedEnd = new Date(pack?.location?.planned_end_date);
  return Number.isFinite(plannedEnd.getTime()) && plannedEnd.getTime() > Date.now();
};
const hasBeenOperational = (pack) => (pack?.history || []).some((entry) => (
  entry?.action === "Status Change"
  && ["In Use", "Returned"].some((status) => (
    entry?.additional_info === status || entry?.additional_info?.startsWith(`${status} - `)
  ))
));

export const getViewPackPermissions = (user, pack) => {
  const superAdmin = isSuperAdmin(user);
  const manager = isPackManager(user);
  const ownsPack = isOwningPlanner(user, pack);
  const primaryEs = isPrimaryEngineeringSupervisor(user, pack);

  return {
    canCheck: (superAdmin || ownsPack) && pack?.status === "Created",
    canEdit: manager && EDITABLE_STATUSES.includes(pack?.status),
    canDuplicate: manager && !["Draft", "Void"].includes(pack?.status),
    canExportPdf: Boolean(user),
    canPublish: (superAdmin || primaryEs) && pack?.status === "Checked",
    canReassign: manager && REASSIGNABLE_STATUSES.includes(pack?.status) && isBeforePlannedEnd(pack),
    canReinstate: (superAdmin || ownsPack) && pack?.status === "Void" && !hasBeenOperational(pack),
    canReject: (superAdmin || primaryEs) && pack?.status === "Checked",
    canVoid: (superAdmin || ownsPack) && VOIDABLE_STATUSES.includes(pack?.status),
  };
};
